export interface IRatingResponse {
    customerGuid: string
    policyNumber: string
    totalWritten: number
    hasPriorCoverage: boolean
    hasPriorBalance: boolean
    previousCarrier: any
    previousExpirationDate: string
    priorBiLimit: string
    priorMonthsInsured: number
    vehicles: Vehicle[]
    coverageLimits: CoverageLimit[]
    writtenByCoverage: WrittenByCoverage[]
    downPayment: number
    installments: Installment[]
    allInstallmentOptions: AllInstallmentOption[]
  }

  export class RatingResponse implements IRatingResponse {
    customerGuid: string = "";
    policyNumber: string = "";
    totalWritten: number = 0;
    hasPriorCoverage: boolean = false;
    hasPriorBalance: boolean = false;
    previousCarrier: any = "";
    previousExpirationDate: string = "";
    priorBiLimit: string = "";
    priorMonthsInsured: number = 0;
    vehicles: Vehicle[] = [];
    coverageLimits: CoverageLimit[] = [];
    writtenByCoverage: WrittenByCoverage[] = [];
    downPayment: number = -1;
    installments: Installment[] = [];
    allInstallmentOptions: AllInstallmentOption[] = [];
  }
  
  export interface Vehicle {
    carNum: number
    vin: string
    year: number
    make: string
    model: string
    bodyStyle: string
    billingType: any
    totalWritten: number
  }
  
  export interface CoverageLimit {
    type: string
    indexNumber: number
    name: string
    description: string
    limit: string
    isUnusedCoverage: boolean
  }
  
  export interface WrittenByCoverage {
    carNumber: number
    name: string
    written: number
    perMile: number
    isUnusedCoverage: boolean
  }
  
  export interface Installment {
    installmentNumber: number
    dueDate: string
    totalPremium: number
    totalFees: number
    totalDue: number
    breakDown: BreakDown[]
  }
  
  export interface BreakDown {
    name: string
    isFee: boolean
    amount: number
  }
  
  export interface AllInstallmentOption {
    payPlanId: number
    payPlanName: string
    downPaymentPercent: number
    installmentCount: number
    installments: Installment2[]
  }
  
  export interface Installment2 {
    installmentNumber: number
    dueDate: string
    totalPremium: number
    totalFees: number
    totalDue: number
    breakDown: BreakDown2[]
  }
  
  export interface BreakDown2 {
    name: string
    isFee: boolean
    amount: number
  }
  